// extracted by mini-css-extract-plugin
export var infoRow = "_s8-2";
export var labelContainer = "_s8-0";
export var rightInfo = "_s8-1";